module.exports = __webpack_public_path__ + "img/solarium.a327fde8.svg";